import classNames from "classnames";
import React from "react";
import { ButtonGroup } from "../../../Button";
import { ModalActionButton, ModalCancelButton } from "./ModalActions";
const ModalFooter = ({ loading, className, onAction, actionText, onCancel, cancelText, children, actionType, }) => {
    if (!actionText && !cancelText && !children)
        return null;
    return (React.createElement("footer", { className: classNames("gerudo-modal-footer", className) }, !children ? (React.createElement(ButtonGroup, null,
        React.createElement(ModalActionButton, { type: actionType, loading: loading, onClick: onAction, text: actionText }),
        React.createElement(ModalCancelButton, { onClick: onCancel, text: cancelText, disabled: loading }))) : (children)));
};
export default ModalFooter;
export { ModalFooter };
//# sourceMappingURL=ModalFooter.js.map